
import { mapState } from 'vuex';

export default {
  name: 'AppReviewOptionsSection',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    userIconUrl() {
      return (
        this.review.brand_user_grade?.icon_url ||
        this.review.brand_author_type?.image_url ||
        ''
      );
    },
    reviewOptions() {
      return [
        ...(this.review.customer_properties ?? []),
        ...(this.review.display_user_options ?? []),
        ...(this.reviewSettings.show_options && this.review.product_options
          ? this.review.product_options
          : [])
      ];
    }
  }
};
